var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLudoArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24281 5.14966L5.71156 7.68091C5.67158 7.71817 5.61869 7.73845 5.56404 7.73749C5.50939 7.73653 5.45725 7.71439 5.41861 7.67574C5.37996 7.63709 5.35782 7.58495 5.35686 7.53031C5.35589 7.47566 5.37618 7.42277 5.41344 7.38278L7.58434 5.21153H1.90625C1.85031 5.21153 1.79665 5.18931 1.75709 5.14975C1.71754 5.11019 1.69531 5.05654 1.69531 5.0006C1.69531 4.94465 1.71754 4.891 1.75709 4.85144C1.79665 4.81188 1.85031 4.78966 1.90625 4.78966H7.58434L5.41344 2.61841C5.37618 2.57842 5.35589 2.52554 5.35686 2.47089C5.35782 2.41624 5.37996 2.3641 5.41861 2.32545C5.45725 2.28681 5.50939 2.26467 5.56404 2.2637C5.61869 2.26274 5.67158 2.28303 5.71156 2.32029L8.24281 4.85154C8.28231 4.89109 8.3045 4.9447 8.3045 5.0006C8.3045 5.0565 8.28231 5.11011 8.24281 5.14966Z",
    fill: "#FBBC04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLudoArrow);
export default __webpack_public_path__ + "static/media/ludoArrow.3e2aedaa82d5d296c40e111616e71e3f.svg";
export { ForwardRef as ReactComponent };